import { type MapObjectLabelConfig } from '~/map/map/mapObjects/mapObject.types';

export const drawingNumberLabelProps: Partial<MapObjectLabelConfig> = {
  letterSpacing: 0,
  verticalAnchor: 'center',
  horizontalAnchor: 'center',
  interactive: false,
};
